module.exports = __webpack_public_path__ + "static/img/7.58c30e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guangdong/7.jpg
// module id = uUnS
// module chunks = 1